import { render, staticRenderFns } from "./AnxinRefundDetail.vue?vue&type=template&id=dc1faf7c&scoped=true"
import script from "./AnxinRefundDetail.vue?vue&type=script&lang=js"
export * from "./AnxinRefundDetail.vue?vue&type=script&lang=js"
import style0 from "./AnxinRefundDetail.vue?vue&type=style&index=0&id=dc1faf7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1faf7c",
  null
  
)

export default component.exports